import {AxiosError} from 'axios';
import {GET_SPE_ADDITIONAL_DETAILS_URL} from '../../constants/apiUrls';
import {GET_SPE_ADDITIONAL_DETAILS_QUERY_KEY} from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {IExamMasterCodeItem} from '../../api/user/model';
import {GenericErrorResponse} from "../typings";
import {Dayjs} from "dayjs";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface SPEAdditionalDetailsResponse {
  name: string;
  hanyuPinyinName: string;
  userIdType: 'NRIC/FIN' | 'PASSPORT';
  nricFinPassport: string;
  passportNo: string;
  email: string;
  nationality: string;
  citizenship: string;
  schoolName: string;
  gender: string;
  dob: string;
  race: string;
  prStatus: string;
  nationalityIssueDate: string;
  mailingAddress: {
    houseOrBlockNumber: string;
    floorNumber: string;
    unitNumber: string;
    buildingName: string;
    streetName: string;
    postalCode: string;
  };
  foreignAddress1: string;
  foreignAddress2: string;
  foreignAddress3: string;
  mobileNumber: {
    countryCode: IExamMasterCodeItem;
    number: string;
  };
  phoneNumber: {
    countryCode: IExamMasterCodeItem;
    number: string;
  };
  nextOfKinName: string;
  nextOfKin: {
    countryCode: IExamMasterCodeItem;
    number: string;
  };
  nextOfKinRelationship: string;
  localAddressPreferred: boolean;
  mobileNumberPreferred: boolean;
  intendedResidentialZone: string;
  overseasResidenceCity: string;
  overseasResidenceCountry: string;
  overseasResidenceState: string;
  overseasResidencePeriodOfResidenceFrom: string;
  overseasResidencePeriodOfResidenceTo: string;
  lockedByUser?: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: SPEAdditionalDetailsResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
}

export const useGetSPEAdditionalDetails = ({onSuccess, onError, uuid}: Input) => {
  const getSPEAdditionalDetails = async () => {
    const res = await axiosClient.get<SPEAdditionalDetailsResponse>(
        GET_SPE_ADDITIONAL_DETAILS_URL(uuid)
    );
    return res.data;
  };

  return useCustomQuery(GET_SPE_ADDITIONAL_DETAILS_QUERY_KEY, getSPEAdditionalDetails, {
    onSuccess,
    onError,
  });
};
